import request from '@/utils/request.js'

export function discountDetailsById(params) {
    return request({
        url:`/discount/details/${params}`,
        method:'get'
    })
}
